import React, { useEffect, useState } from 'react';
import { Clock, MapPin, Phone, Printer, Mail } from 'lucide-react';

import './contact.css'
import OCP from '../../Images/OCP.png';

const ContactUs = () => {

    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // const heroOpacity = Math.max(0, 1 - scrollY / 500);
    // const heroScale = Math.max(0.9, 1 - scrollY / 2000);

    // Default placeholder image if none provided
    //   const bgImage = pharmacyImage || "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&h=800&fit=crop";

    return (
        <>

            <div className='home-container'>

                <div className='home-titles'>
                    <div className='home-heading'>
                        {/* <p>Midtown Medical Pharmacy</p> */}
                        <p>Visit us today</p>
                        <p>We're here to answer your questions and serve your healthcare needs.</p>
                    </div>

                    <div className='rx-div'>
                        {/* <a href="">Transfer your Rx for free</a> */}
                        {/* <Link to="/rx-form">
                            Transfer your Rx for free
                        </Link> */}
                    </div>
                </div>

            </div>

            <div className="contact-container">
                {/* Hero Section */}
                {/* <section
                    className="hero-section"
                    style={{
                        opacity: heroOpacity,
                        transform: `scale(${heroScale})`
                    }}
                >
                    <div className="hero-overlay"></div>
                    <div className="hero-gradient"></div>

                 
                    <div className="hero-bg-animation">
                        <div className="hero-blob hero-blob-1"></div>
                        <div className="hero-blob hero-blob-2"></div>
                    </div>

                    <div className="hero-content">
                        <div className="hero-icon-wrapper">
                            <Heart className="hero-icon" strokeWidth={1.5} />
                        </div>
                        <h1 className="hero-title">
                            Get in Touch
                        </h1>
                        <p className="hero-description">
                            We're here to answer your questions and serve your healthcare needs
                        </p>
                    </div>

                    <div className="scroll-indicator">
                        <div className="scroll-indicator-border">
                            <div className="scroll-indicator-dot"></div>
                        </div>
                    </div>
                </section> */}

                {/* Contact Information Section with Background Image */}
                <section
                    className="contact-info-section"
                    style={{
                        // backgroundImage: `url(${bgImage})`
                    }}
                >
                    <div className="contact-info-overlay"></div>

                    <div className="contact-info-container">
                        <div className="contact-info-grid">
                            <div className="contact-info-card">
                                <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <MapPin className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Address</div>
                                        <div className="contact-info-text">
                                            130 Wilson Street<br />
                                            Hamilton, Ontario L8R 1E2, Canada
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <Clock className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Hours</div>
                                        <div className="contact-info-text">
                                            Monday to Friday: 9:00 AM - 6:00 PM<br />
                                            Saturday: 9:00 AM - 12:00 PM<br />
                                            Sunday: Closed
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <Phone className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Phone</div>
                                        <div className="contact-info-text">
                                            <a href="tel:+15551234567">(905) 577-4000</a>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="contact-info-card">
                                <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <Printer className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Fax</div>
                                        <div className="contact-info-text">
                                            <a href="tel:+15551234568">(905) 577-4007</a>
                                        </div>
                                    </div>
                                </div>

                                <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <Mail className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Email</div>
                                        <div className="contact-info-text">
                                            <a href="mailto:info@midtownpharmacy.com">mtmedicalpharmacy@gmail.com</a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="contact-info-item">
                                    <div className="contact-icon-wrapper">
                                        <Mail className="contact-icon" />
                                    </div>
                                    <div className="contact-info-content">
                                        <div className="contact-info-label">Upload Prescription</div>
                                        <div className="contact-info-text">
                                            <a href="mailto:info@midtownpharmacy.com">link a form here??</a>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
                <iframe
                    title="Pharmacy Location"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2905.7266078181706!2d-79.86459912433261!3d43.25715127795689!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c9b8f73a62e59%3A0xa6880864eb34434!2sMidtown%20Medical%20Pharmacy!5e0!3m2!1sen!2sca!4v1745803854584!5m2!1sen!2sca"
                    width="600"
                    height="450"
                    className='google-map'
                ></iframe>

                <footer class="footer">

                    <div class="accreditation">
                        <img
                            src={OCP}
                            alt="Ontario College of Pharmacists Accredited"
                        />
                    </div>

                    <div classname='accred-number'>
                        <p>
                            Accredited by the Ontario College of Pharmacists<br />
                            Accreditation <b>No. 310443</b>
                        </p>
                    </div>


                </footer>
            </div>


        </>

    )

};

export default ContactUs;